import { type Media } from '@/infra/services/catalog/product/get-product-info/model';

import { Content } from './Content';
import { styles } from './Item.styles';

export interface ItemProps {
  type: Media['type'] | 'warrant';
  title: string;
  link?: string;
  testId: string;
}

export default function Item(props: Readonly<ItemProps>) {
  const { type, title, link, testId } = props;

  const classNames = styles();

  const isDownloadable = Boolean(link);

  return (
    <div className={classNames.wrapper()} data-testid={testId}>
      {isDownloadable ? (
        <a
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="item-link"
        >
          <Content type={type} title={title} isDownloadable={isDownloadable} />
        </a>
      ) : (
        <Content type={type} title={title} isDownloadable={isDownloadable} />
      )}
    </div>
  );
}
